export const CAR_SPACES_ATTR_VAL = 'carSpaces';
export const PROPERTY_TYPE_ATTR_VAL = 'propertyType';

const PROPERTY_ATTRIBUTE = [
    { label: 'Bedroom', value: 'bedrooms', hasEditableUnits: false, },
    { label: 'Bathroom', value: 'bathrooms', hasEditableUnits: false, },
    { label: 'Car', value: CAR_SPACES_ATTR_VAL, hasEditableUnits: false, },
    { label: 'Land Size', value: 'landArea', hasEditableUnits: true, },
    { label: 'Floor Area', value: 'floorArea', hasEditableUnits: false, },
];

export const UPDATE_DATA_ATTRIBUTES = [
    ...PROPERTY_ATTRIBUTE,
    { label: 'Property Type', value: PROPERTY_TYPE_ATTR_VAL },
];

export default PROPERTY_ATTRIBUTE;
